import type { LinkProps as NextLinkProps } from "next/link";

import classNames from "classnames";

import type { SupportedLocales } from "@/shared/types";

import { Link as NextIntlLink } from "@/shared/lib/navigation";

import styles from "./Link.module.css";

type LinkProps = {
    children: React.ReactNode;
    locale?: SupportedLocales;
    variant?: "button" | "link";
} & Omit<NextLinkProps, "locale">;

export function Link({ children, variant = "link", ...props }: LinkProps) {
    return (
        <NextIntlLink
            {...props}
            className={classNames(styles.link, styles[`link__${variant}`], styles.link__fullWidth)}
        >
            {children}
        </NextIntlLink>
    );
}
